define('../app/fukit/view/block/notes.view',['require','exports','module','underscore','backbone','../../behavior/bind.and.format.option.values.behavior','./content.management.item.view','./content.management.title.and.actions.view','../../helpers/extend.util','../../behavior/fuzzy.search.behavior','./grid.container.view','../../behavior/invoke.model.method.on.event.behavior','appkit/util/key.prefixer','marionette','../../behavior/named.state.behavior','./note.body.view','./note.footer.message.view','backbone.radio','../../behavior/show.modal.on.navigate.with.unsaved.changes.behavior','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _                                             = require('underscore'),
      Backbone                                      = require('backbone'),
      BindAndFormatOptionValuesBehavior             = require('../../behavior/bind.and.format.option.values.behavior'),
      ContentManagementItemView                     = require('./content.management.item.view'),
      ContentManagementTitleAndActionsView          = require('./content.management.title.and.actions.view'),
      ExtendUtil                                    = require('../../helpers/extend.util'),
      FuzzySearchBehavior                           = require('../../behavior/fuzzy.search.behavior'),
      GridContainerView                             = require('./grid.container.view'),
      InvokeModelMethodOnEventBehavior              = require('../../behavior/invoke.model.method.on.event.behavior'),
      KeyPrefixer                                   = require('appkit/util/key.prefixer'),
      Mn                                            = require('marionette'),
      NamedStateBehavior                            = require('../../behavior/named.state.behavior'),
      NoteBodyView                                  = require('./note.body.view'),
      NoteFooterMessageView                         = require('./note.footer.message.view'),
      Radio                                         = require('backbone.radio'),
      ShowModalOnNavigateWithUnsavedChangesBehavior = require('../../behavior/show.modal.on.navigate.with.unsaved.changes.behavior'),
      UIKit                                         = require('uikit/uikit');


  var NOTE_ATTRIBUTE_MAP = {
    title: 'title',
    body: 'body',
    attachmentPoint: 'attachmentPoint',
    createdByName: 'createUserModel.personModel.fullName',
    lastModifiedByName: 'updateUserModel.personModel.fullName',
    createdOn: 'createDate',
    lastModifiedOn: 'updateDate'
  }

  var NotesView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="actionsView"/><ui name="notesView"/>'
    },

    className: 'notes main container',

    behaviors: function() {
      return {
        NamedStateBehavior: {
          states: {
            selectedNote: {
              isSelectable: true,
              newModelDefaults: {
                title: '',
                body: '',
                attachmentPoint: '@state.primaryId'
              }
            }
          },
          behaviorClass: NamedStateBehavior
        }
      }
    },

    internalViewOptions: {
      actionsView: function() {
        return {
          type: GridContainerView,
          className: 'ui basic fitted celled segment grid new note container',
          components: [
            {
              aligned: 'right',
              newNoteButton: this.getOption('newNoteButton'),
              content: ExtendUtil.extendOptionValueWithDefaults('newNoteButton', {
                type: UIKit.Button.extend({
                  behaviors: {
                    InvokeModelMethodOnEventBehavior: {
                      method: 'insertNewModel',
                      behaviorClass: InvokeModelMethodOnEventBehavior
                    }
                  }
                }),
                color: 'primary',
                text: 'New Note',
                model: this.getState('selectedNote')
              })
            }
          ]
        }
      },
      notesView: function() {
        return {
          type: GridContainerView,
          className: 'ui celled segment notes content container grid',

          components: [
            {
              type: GridContainerView.RowView,
              components: [
                {
                  type: GridContainerView.ColumnView.extend({
                    className: GridContainerView.ColumnView.prototype.className + ' note search container'
                  }),
                  size: 6,
                  content: {
                    type: UIKit.Input,
                    icon: 'search',
                    placeholder: 'Click to search...',
                    fluid: true,
                    behaviors: {
                      FuzzySearchBehavior: {
                        fuzzyFields: [NOTE_ATTRIBUTE_MAP.title, NOTE_ATTRIBUTE_MAP.body],
                        searchResultCollection: this.getOption('collection'),
                        behaviorClass: FuzzySearchBehavior
                      }
                    }
                  }
                },
                {
                  type: GridContainerView.ColumnView.extend({
                    className: GridContainerView.ColumnView.prototype.className + ' note header container'
                  }),
                  size: 10,
                  color: 'tertiary',
                  titleAndActions: this.getOption('titleAndActions'),
                  content: ExtendUtil.extendOptionValueWithDefaults('titleAndActions', {
                    type: ContentManagementTitleAndActionsView,
                    state: this.getState('selectedNote'),
                    selectedItemAttribute: 'selectedModel',
                    titlePlaceholder: 'Enter note title here...',
                    attributeMap: NOTE_ATTRIBUTE_MAP
                  })
                }
              ]
            },
            {
              type: GridContainerView.RowView,
              components: [
                {
                  type: GridContainerView.ColumnView.extend({
                    className: GridContainerView.ColumnView.prototype.className + ' note list container'
                  }),
                  size: 6,
                  content: {
                    type: UIKit.Table,
                    name: 'notesListView',
                    model: this.getState('selectedNote'),
                    headless: true,
                    borderless: true,
                    selectable: true,
                    selection: 'single',
                    columns: [
                      {
                        childView: ContentManagementItemView,
                        childViewOptions: {
                          attributeMap: NOTE_ATTRIBUTE_MAP
                        }
                      }
                    ],
                    bindings: {
                      collection: 'selectableCollection',
                      value: 'selectedModel'
                    },
                    childViewOptions: {
                      attributes: {
                        class: 'note item'
                      }
                    }
                  },
                  attributes: {
                    style: 'padding: 0;',
                  }
                },
                {
                  type: GridContainerView.ColumnView.extend({
                    className: GridContainerView.ColumnView.prototype.className + ' note body container'
                  }),
                  size: 10,
                  color: 'warning',
                  content: {
                    type: GridContainerView,
                    components: [
                      {
                        size: 16,
                        content: {
                          type: NoteBodyView,
                          behaviors: {
                            BindAndFormatOptionValuesBehavior: {
                              optionValues: {
                                model: {
                                  model: this.getState('selectedNote'),
                                  modelAttribute: 'selectedModel'
                                }
                              },
                              behaviorClass: BindAndFormatOptionValuesBehavior
                            }
                          }
                        }
                      },
                      {
                        className: GridContainerView.ColumnView.prototype.className + ' note message bottom container',
                        size: 16,
                        content: {
                          name: 'notesMessageBottomView',
                          type: NoteFooterMessageView,
                          attributeMap: NOTE_ATTRIBUTE_MAP,
                          behaviors: {
                            BindAndFormatOptionValuesBehavior: {
                              optionValues: {
                                model: {
                                  model: this.getState('selectedNote'),
                                  modelAttribute: 'selectedModel'
                                },
                                visible: {
                                  formatWithoutResource: true,
                                  formatter: function(model) {
                                    return !!model && !model.isNew();
                                  }
                                }
                              },
                              behaviorClass: BindAndFormatOptionValuesBehavior
                            }
                          }
                        }
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      }
    }
  });

  module.exports = NotesView;
});

